import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=b1cb5e64&scoped=true"
var script = {}
import style0 from "./Profile.vue?vue&type=style&index=0&id=b1cb5e64&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cb5e64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1cb5e64')) {
      api.createRecord('b1cb5e64', component.options)
    } else {
      api.reload('b1cb5e64', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=b1cb5e64&scoped=true", function () {
      api.rerender('b1cb5e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aboutUS/components/Profile.vue"
export default component.exports